import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIFetchRequestOptions } from '@sondermind/utilities/models-http';

import {
  IQuickCheckoutApiResponse,
  IQuickCheckoutReferralCreationRequest,
  IQuickCheckoutReferralRequestCreationBody,
  IQuickCheckoutReferralRequestResponse,
  ISagaStatusResponse
} from '../models/quick-checkout-form.model';

@Injectable({
  providedIn: 'root'
})
export class QuickCheckoutHttpService {
  constructor(
    private httpService: HttpService,
    private configurationService: ConfigurationService
  ){}

  resendEmailVerification$(
    referralRequestUuid: string,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<void> {
    const path = `referrals/referral_requests/${referralRequestUuid}/resend_invitation`;
    const apiUrl = `${this.configurationService.env.svcBase}/${path}`;
    const params = this.httpService.generateFetchParams(opts);

    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    return this.httpService.post<void>(apiUrl, {}, params)
      .pipe(
        this.httpService.handleHttpErrorStrict()
      );
  }

  submitQuickCheckout$(
    body: IQuickCheckoutReferralCreationRequest,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<IQuickCheckoutApiResponse | null> {
    const apiUrl = `${this.configurationService.env.dataExchangeSvcBase ?? ''}/public/v1/referrals`;
    const params = this.httpService.generateFetchParams(opts);

    return this.httpService.post<IQuickCheckoutApiResponse>(apiUrl, body, params)
      .pipe(
        this.httpService.handleHttpError()
      );
  }

  submitQuickCheckoutWithRequestedTimeSlot$(
    body: IQuickCheckoutReferralCreationRequest,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<IQuickCheckoutApiResponse | null> {
    const apiUrl = `${this.configurationService.env.dataExchangeSvcBase ?? ''}/public/v1/appointments`;
    const params = this.httpService.generateFetchParams(opts);

    return this.httpService.post<IQuickCheckoutApiResponse>(apiUrl, body, params)
      .pipe(
        this.httpService.handleHttpError()
      );
  }

  createReferralRequest$(
    body: IQuickCheckoutReferralRequestCreationBody,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<IQuickCheckoutReferralRequestResponse | null> {
    const apiUrl = `${this.configurationService.env.dataExchangeSvcBase ?? ''}/public/v1/referral_requests/psl`;
    const params = this.httpService.generateFetchParams(opts);

    return this.httpService.post<IQuickCheckoutReferralRequestResponse>(apiUrl, body, params)
      .pipe(
        this.httpService.handleHttpError()
      );
  }

  getSagaStatus$(
    sagaId: string,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<ISagaStatusResponse | null> {
    const apiUrl = `${this.configurationService.env.dataExchangeSvcBase ?? ''}/api/v1/sagas/${sagaId}`;
    const params = this.httpService.generateFetchParams(opts);

    return this.httpService.get<ISagaStatusResponse>(apiUrl, params)
      .pipe(
        this.httpService.handleHttpError()
      );
  }
}
